// components/monitoring/MinScaleToggleButton.tsx
import React from 'react';
import { useDispatch } from 'react-redux';
import { toggleMinScale } from '../../store/slices/monitoringSlice';
import { AppDispatch } from '../../store';

interface MinScaleToggleButtonProps {
    resourceGroup: string;
    appName: string;
    id: string;
    isAlwaysActive?: boolean;
    minReplicas?: number;
    disabled?: boolean;
    className?: string;
    iconOnly?: boolean;
}

const MinScaleToggleButton: React.FC<MinScaleToggleButtonProps> = ({
    resourceGroup,
    appName,
    id,
    isAlwaysActive = false,
    minReplicas = 0,
    disabled = false,
    className = '',
    iconOnly = false
}) => {
    const dispatch = useDispatch<AppDispatch>();

    // Determine if it's active based on minReplicas or isAlwaysActive prop
    const active = isAlwaysActive || minReplicas > 0;
    const handleToggle = (e: React.MouseEvent) => {
        // Stop event propagation to prevent row click
        e.stopPropagation();

        if (disabled) return;
        dispatch(toggleMinScale({ resourceGroup, appName }));
    };

    return (
        <button
            type="button"
            onClick={handleToggle}
            disabled={disabled}
            className={`${active
                ? 'bg-green-100 text-green-800 hover:bg-green-200 dark:bg-green-700 dark:text-green-100 dark:hover:bg-green-600'
                : 'bg-gray-100 text-gray-800 hover:bg-gray-200 dark:bg-gray-700 dark:text-gray-100 dark:hover:bg-gray-600'} 
        ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'} 
        transition-colors duration-200 rounded-md ${iconOnly ? 'p-2' : 'px-3 py-2'} ${className}`}
            title={active ? "Turn off Always Active mode" : "Turn on Always Active mode"}
            aria-label={active ? "Turn off Always Active mode" : "Turn on Always Active mode"}
        >
            {/* Icon for the power state */}
            <span className="inline-flex items-center">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className={`${iconOnly ? 'h-5 w-5' : 'h-4 w-4 mr-1'}`}
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M13 10V3L4 14h7v7l9-11h-7z"
                    />
                </svg>
                {!iconOnly && (active ? "Scale to Zero" : "Always Active")}
            </span>
        </button>
    );
};

export default MinScaleToggleButton;